import { render, staticRenderFns } from "./article-info.vue?vue&type=template&id=3190f383"
import script from "./article-info.vue?vue&type=script&lang=js"
export * from "./article-info.vue?vue&type=script&lang=js"
import style0 from "./article-info.vue?vue&type=style&index=0&id=3190f383&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports